module.exports = __webpack_public_path__ + "static/media/Luna Lovegood 1.896ebaae.jpg";